import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Menu } from 'antd';
import { logout, selectorPermissions, selectorUserInfo } from '@/stores/auth';
import LogoUrl from '@/assets/images/logo.png';
import {
  CalendarAltSvg,
  CogSvg,
  HomeSvg,
  LockSvg,
  FileAltSvg,
  SignOutAltSvg,
  TachometerAltSvg,
  TasksSvg,
  UserSvg,
  UsersSvg,
  CaretDownSvg,
} from '@/assets/icons';
import Button from '@/components/button';
import { StyledHeader } from './styles';

const Header = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectorUserInfo);
  const permissions = useSelector(selectorPermissions);
  const { pathname } = useLocation();
  const keys = pathname === '/reports/newreports.aspx' ? ['reports'] : pathname.split('/').slice(1);

  const userMenuItems = [
    {
      key: 'user',
      label: <Link to="/user/change-password">Change Password</Link>,
      icon: <LockSvg />,
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <SignOutAltSvg />,
      onClick: () => {
        dispatch(logout());
      },
    },
  ];

  const mainMenuItems = [
    {
      label: <a href="/dashboards/select">Dashboard</a>,
      key: 'dashboards',
      icon: <TachometerAltSvg />,
    },
    {
      label: <Link to="/child">Children</Link>,
      key: 'child',
      icon: <UsersSvg />,
    },
    {
      label: <Link to="/parent">Parents</Link>,
      key: 'parent',
      icon: <HomeSvg />,
    },
    permissions.events && {
      label: <a href="/events">Events</a>,
      key: 'events',
      icon: <CalendarAltSvg />,
    },
    permissions.reports && {
      label: <a href="/reports/newreports.aspx">Reports</a>,
      key: 'reports',
      icon: <FileAltSvg />,
    },
    permissions.referralManagement && {
      label: 'Referral Management',
      key: 'referralmanagement',
      icon: <TasksSvg />,
      children: [
        {
          label: <a href="/referralmanagement">Photo Referrals</a>,
          key: 'referralmanagement-photo',
        },
        {
          label: <a href="/referralmanagement/csreferrals.aspx">CS Referrals</a>,
          key: 'referralmanagement-cs',
        },
      ],
    },
    permissions.admin && {
      label: <a href="/admin">Admin</a>,
      key: 'admin',
      icon: <CogSvg />,
    },
  ].filter((item) => item);

  return (
    <StyledHeader>
      <Link to="/" className="brand">
        <img src={LogoUrl} width="97" alt="Logo" />
      </Link>

      <Menu mode="horizontal" selectedKeys={keys} items={mainMenuItems} />

      <Dropdown menu={{ items: userMenuItems, selectedKeys: keys }}>
        <Button type="link" className="user-button" style={{ gap: 6, color: 'inherit' }}>
          <UserSvg /> {userInfo.fullName}
          <CaretDownSvg />
        </Button>
      </Dropdown>
    </StyledHeader>
  );
};

export default Header;
